// Libraries
import React, { useEffect, useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import styled from "styled-components";
import LogoutIcon from "@mui/icons-material/Logout";
import Spinner from "react-bootstrap/Spinner";
import {
  Document,
  Packer,
  Paragraph,
  HeadingLevel,
  TextRun,
  AlignmentType,
  SectionType,
  LineRuleType,
  ExternalHyperlink,
  ImageRun,
  Table,
  TableRow,
  TableCell,
  BorderStyle,
} from "docx";
import { saveAs } from "file-saver";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { Button } from "react-bootstrap";
import numberToWords from "number-to-words";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { Markup } from "interweave";
import HabilisLogo from "../assets/icons/habilis_logo_new.png";

// import DocViewer from "react-doc-viewer";

// Components
import CurrentConvo from "./CurrentConvo";
import OldConvo from "./OldConvo";
import ChatHistory from "./chat-history/ChatHistory";
import Dashboard from "./dashboard/Dashboard";
import HHPCConvo from "./HHPCConvo";
import HHPCOldChat from "./HHPCOldChat";
// import Drag from "./drag/Drag";

// Constants
import { Language_Models, PROJECT_NAME } from "../constants/AppConstant";
import { API, getURL } from "../constants/APIConstant";

// Styles
import "./ChatApp.scss";
import "./styles/reset.css";
import "react-toastify/dist/ReactToastify.css";

// import QueryStatsIcon from "@mui/icons-material/QueryStats";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

// Assets
// import logo from "../assets/icons/Kbr.png";
import logo from "../assets/icons/KbrNew.png";
import HomeIcon from "@mui/icons-material/Home";
import { InvokePostServiceCall } from "../api/apiServices";
import { Autocomplete, Backdrop, TextField } from "@mui/material";
import { marked } from "marked";

export const TopStrip = styled.div`
  background-color: #004987;
  display: flex;
  padding: 5px;
  text-align: center;
  color: white;
  flex-shrink: 0;
  width: 100%;
  border: 2px ridge;
`;

export const Message = styled.div`
  margin-bottom: 10px;
  padding: 8px;
  text-align: left;
  border-radius: 5px;
  background-color: ${(props) =>
    props.sender === "user" ? "#e6f7ff" : "white"};
  align-self: ${(props) =>
    props.sender === "user" ? "flex-end" : "flex-start"};
`;

export const ChatInput = styled.div`
  display: flex;
  padding: 5px;
  overflow: hidden;
  position: absolute;
  width: -webkit-fill-available;
  width: -moz-available;
  bottom: 0;
  align-items: center;
  justify-content: space-between;
  background-color: white;
  border-top: 1px solid #ccc;
  padding: 5px;
`;

export const SendButton = styled.button`
  padding: 8px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  background-color: #00783f;
  color: white;
  width: 40px;
  height: 42px;
`;

const statistics = [
  {
    stat: "gpu_fan",
    value: "0%",
  },
  {
    stat: "gpu_util",
    value: "0%",
  },
  {
    stat: "memory_usg",
    value: "0MiB / 23028MiB",
  },
  {
    stat: "power_usg",
    value: "0W / 300W",
  },
  {
    stat: "temp",
    value: "0C",
  },
];

const ChatApp = ({ setIsLoggedIn }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { EVR, HEALTH_CARE, POLICY_NAVIGATOR } = PROJECT_NAME;
  const [data, setData] = useState("");
  const [userInput, setUserInput] = useState("");
  const [allChat, setAllChat] = useState([]);
  const [chat, setChat] = useState([]);
  const [stats, setStats] = useState(statistics);
  const [gifyOpen, setGifyOpen] = useState(false);
  // const [imgOpen, setImgOpen] = useState(false);
  const [gpuStatistic, setGPUStatistics] = useState(null);
  const [isHidePrevChatPanel, setHidePrevChatPanel] = useState(false);
  const [dashboardStats, setDashboardStats] = useState(null);
  const [pid, setPid] = useState(null);
  const [selectedTab, setSelectTab] = useState(
    location?.state?.selectedTab
      ? location?.state?.selectedTab
      : POLICY_NAVIGATOR
  );
  const isUseModel = location?.state?.isUseModel
    ? location.state.isUseModel
    : false;
  const [textOnly, setTextOnly] = useState(true);
  const [inlineRef, setInlineRef] = useState(false);
  const [addReport, setAddReport] = useState(true);
  const [languageModel, setLanguageModel] = useState({
    title: "GPT-4 Turbo Preview (Open AI)",
    value: "gpt-4-0125-preview",
  });

  // Health Care chat bot
  const [healthCareData, setHealthCareData] = useState("");
  const [healthCareUserInput, setHealthCareUserInput] = useState("");
  const [healthCareAllChat, setHealthCareAllChat] = useState([]);
  const [healthCareChat, setHealthCareChat] = useState([]);
  const [healthCarePid, setHealthCarePid] = useState(null);

  // EVR Chat Bot
  const [evrAllChat, setEVRAllChat] = useState([]);
  const [evrPid, setEVRPid] = useState(null);
  const [evrChat, setEVRChat] = useState([]);
  const [report, setReport] = useState({
    title: "",
    description: [],
    isFilled: false,
  });
  const [showSpinner, setShowSpinner] = useState(false);
  const [openfullWidthChat, setOpenFullWidthChat] = useState(true);
  const [openfullWidthReport, setOpenFullWidthReport] = useState(true);
  // eslint-disable-next-line no-unused-vars
  // const [sectionIndex, setSectionIndex] = useState("");
  // const [docBlob, setBlob] = useState(null);
  const isPolicyNavigator = selectedTab === POLICY_NAVIGATOR;

  // HHPC EVR chat
  const [hhpcData, setHHPCData] = useState("");
  const [hhpcInput, setHHPCUserInput] = useState("");
  const [hhpcChat, setHHPCChat] = useState([]);
  const [hhpcPid, setHHPCPid] = useState(null);
  const [hhpcAllChat, setHHPCAllChat] = useState([]);
  const [hhpcReport, setHHPCeport] = useState({
    title: "",
    description: [],
    isFilled: false,
  });
  const [selectedHHPCSection, setHHPCSelectedSection] = useState(null);
  const [configurationLoading, setConfigurationLoading] = useState(false);
  const [configurationData, setConfigurationData] = useState({
    language_model: {
      title: "Meta Llama3.1 405B Instruct v1:0",
      value: "meta.llama3-1-405b-instruct-v1:0",
    },
    max_tokens: "",
    temperature: "",
    top_p: "None",
    repetition_penalty: "None",
    system_prompt: "",
    k: "",
  });

  const handleConfiguration = () => {
    setConfigurationLoading(true);

    let requestBody = {
      project_id: location.state.projectId,
    };
    InvokePostServiceCall(API.get_configuration, requestBody)
      .then((response) => response.text())
      .then((result) => {
        let res = JSON.parse(result);
        let temperature = "" + res[0].temperature;
        if (temperature.includes("0.1")) {
          temperature += " (Precise)";
        } else if (temperature.includes("0.5")) {
          temperature += " (Balanced)";
        } else if (temperature.includes("0.7")) {
          temperature += " (Creative)";
        } else if (temperature.includes("1.0")) {
          temperature += " (Inventive)";
        }

        let tempLanguageModel = "";
        for (let i = 0; i < Language_Models.length; i++) {
          if (Language_Models[i].value === res[0].language_model) {
            tempLanguageModel = {
              title: Language_Models[i].title,
              value: Language_Models[i].value,
            };
            break;
          }
        }
        setConfigurationData({
          language_model: tempLanguageModel,
          max_tokens: res[0].max_tokens,
          temperature: temperature,
          top_p: res[0].top_p,
          repetition_penalty: res[0].repetition_penalty,
          system_prompt: res[0].system_prompt,
          k: res[0].k,
        });
        setConfigurationLoading(false);
      })
      .catch((error) => {
        console.log(error);
        notify();
        setConfigurationLoading(false);
      });
  };

  const handleSaveConfiguration = (languageModel, searchKwargs = "") => {
    setConfigurationLoading(true);
    let requestBody = {
      project_name: location.state.projectId,
      language_model: languageModel.value,
      max_tokens: configurationData.max_tokens,
      temperature: configurationData.temperature.split(" ")[0],
      // top_p: configurationData.top_p,
      top_p: "None",
      // repetition_penalty: configurationData.repetition_penalty,
      repetition_penalty: "None",
      system_prompt: configurationData.system_prompt,
      k: searchKwargs !== "" ? searchKwargs : configurationData.k,
      // k: "None",
    };

    InvokePostServiceCall(API.model_parameters, requestBody)
      .then((response) => response.text())
      .then((result) => {
        setConfigurationLoading(false);
        const notify = () => toast.success("Saved Sucessfully!");
        notify();
      })
      .catch((error) => {
        console.error(error);
        notify();
        setConfigurationLoading(false);
      });
  };

  useEffect(() => {
    if (!isUseModel) {
      handleConfiguration();
    }
  }, []);

  const handleClick = () => {
    navigate("/");
    setIsLoggedIn(false);
    sessionStorage.clear("accesstoken");
    sessionStorage.clear("userName");
  };

  const closePreviousChatPanel = () => {
    setHidePrevChatPanel(!isHidePrevChatPanel);
  };

  const setAllChatHistory = (newChat = null) => {
    let currPid = null;
    let allChats = [];
    let currChat = [];
    let chatList = [];
    switch (selectedTab) {
      case POLICY_NAVIGATOR:
        currChat = chat;
        currPid = pid;
        allChats = [...allChat];
        if (newChat !== null) {
          chatList.push({
            question: newChat.question,
            response: newChat.response,
          });
        }
        break;
      case HEALTH_CARE:
        currChat = healthCareChat;
        currPid = healthCarePid;
        allChats = [...healthCareAllChat];
        if (newChat !== null) {
          chatList.push({
            question: newChat.question,
            response: newChat.response,
          });
        }
        break;
      case EVR:
        // currChat = evrChat;
        // currPid = evrPid;
        // allChats = [...evrAllChat];
        currChat = hhpcChat;
        currPid = hhpcPid;
        allChats = [...hhpcAllChat];
        if (newChat !== null) {
          chatList.push({
            question: newChat.question,
            response: newChat.response,
            references: newChat.references,
            executed_at: newChat.executed_at,
          });
        }
        break;
      default:
        break;
    }
    // New query asked add in history
    if (newChat !== null) {
      // No history
      if (allChats.length === 0) {
        const allchat = [
          {
            name:
              selectedTab === EVR
                ? // ? report.title
                  //     ? report.title
                  newChat.question
                  ? newChat.question
                  : "Draft " + newChat.pid //(allChats.length + 1)
                : newChat.question,
            chatList: chatList,
            pid: newChat.pid,
          },
        ];
        if (selectedTab === POLICY_NAVIGATOR) {
          setAllChat(allchat);
        } else if (selectedTab === HEALTH_CARE) {
          setHealthCareAllChat(allchat);
        } else {
          // allChat
          // setEVRAllChat(allchat);
          setHHPCAllChat(allchat);
        }
      } else {
        // Select Old Chat
        allChats.unshift({
          name:
            selectedTab === EVR
              ? // ? report.title
                //     ? report.title
                newChat.question
                ? newChat.question
                : "Draft " + newChat.pid // (allChats.length + 1)
              : newChat.question,
          chatList: chatList,
          pid: newChat.pid,
        });
        if (selectedTab === POLICY_NAVIGATOR) {
          setAllChat(allChats);
        } else if (selectedTab === HEALTH_CARE) {
          setHealthCareAllChat(allChats);
        } else {
          // allChat
          // setEVRAllChat(allChats);
          setHHPCAllChat(allChats);
        }
      }
    } else if (currChat.length > 0) {
      let chats = {
        name:
          selectedTab === POLICY_NAVIGATOR
            ? chat[0].question
            : selectedTab === HEALTH_CARE
            ? healthCareChat[0].question
            : report.title
            ? report.title
            : "Draft " + currPid, // (allChats.length + 1),
        chatList: currChat,
        pid: currPid,
      };

      const index = allChats.findIndex((chatlist) => {
        return chatlist.pid === currPid;
      });
      if (index !== -1) {
        allChats[index].chatList = currChat;
      } else {
        allChats.push(chats);
      }
      switch (selectedTab) {
        case POLICY_NAVIGATOR:
          setAllChat(allChats);
          setPid(null);
          setChat([]);
          break;
        case HEALTH_CARE:
          setHealthCareAllChat(allChats);
          setHealthCarePid(null);
          setHealthCareChat([]);
          break;
        case EVR:
          setHHPCAllChat(allChats);
          setEVRPid(null);
          setHHPCPid(null);
          // setEVRChat([]);
          setHHPCChat([]);
          // setReport({
          //   title: "",
          //   description: [],
          //   isFilled: false,
          // });
          setHHPCeport({
            title: "",
            description: [],
            isFilled: false,
          });
          break;
        default:
          break;
      }
    }
  };
  const setPreviousChat = (prevChat) => {
    let currChat = [];
    let currPid = null;
    let allChats = [];
    let index = -1;
    switch (selectedTab) {
      case POLICY_NAVIGATOR:
        currChat = chat;
        currPid = pid;
        allChats = [...allChat];
        break;
      case HEALTH_CARE:
        currChat = healthCareChat;
        currPid = healthCarePid;
        allChats = [...healthCareAllChat];
        break;
      case EVR:
        // currChat = evrChat;
        // currPid = evrPid;
        // allChats = [...evrAllChat];
        currChat = hhpcChat;
        currPid = hhpcPid;
        allChats = [...hhpcAllChat];
        break;
      default:
        break;
    }

    if (currChat.length !== 0) {
      index = allChats.findIndex((chatlist) => {
        return chatlist.pid === currPid;
      });
    }
    switch (selectedTab) {
      case POLICY_NAVIGATOR:
        if (index !== -1) {
          allChats[index].chatList = chat;
          setAllChat(allChats);
        }
        setPid(prevChat.pid);
        setChat(prevChat.chatList);
        break;
      case HEALTH_CARE:
        if (index !== -1) {
          allChats[index].chatList = healthCareChat;
          setHealthCareAllChat(allChats);
        }
        setHealthCarePid(prevChat.pid);
        setHealthCareChat(prevChat.chatList);
        break;
      case EVR:
        if (index !== -1) {
          // allChats[index].chatList = evrChat;
          allChats[index].chatList = hhpcChat;
          allChats[index].reportList = [...hhpcReport.description];
          // setEVRAllChat(allChats);
          setHHPCAllChat(allChats);
        }
        // setEVRPid(prevChat.pid);
        setHHPCPid(prevChat.pid);
        // setEVRChat(prevChat.chatList);

        let regex = /\[\d+\]/g;
        let tempRef = prevChat.chatList[0].response.references?.split("\n");

        let matches = prevChat.chatList[0].response.references?.match(regex);
        let resultCopy = prevChat.chatList[0].response.result;

        for (let i = 0; i < matches?.length; i++) {
          if (resultCopy.includes(matches[i])) {
            let link = "";
            let index = tempRef.findIndex((item) => item.includes(matches[i]));

            if (index > -1) {
              link = tempRef[index].replace(matches[i], "");
              console.log(link);
              resultCopy = resultCopy.replaceAll(
                matches[i],
                // `<a href=${link}>${matches[i]}</a>`
                `[${matches[i]}](${link})`
              );
            }
            // result.result.replaceAll("[1]",`<a href=${link}></a>`)
          }
        }
        // prevChat.chatList[0].response.result = resultCopy;
        setHHPCChat(prevChat.chatList);
        // setReport({
        //   title: prevChat.name,
        //   description: prevChat.reportList ? prevChat.reportList : [],
        //   isFilled: false,
        // });
        setHHPCeport({
          title: prevChat.name,
          description: prevChat.reportList ? prevChat.reportList : [],
          isFilled: false,
        });
        break;
      default:
        break;
    }
  };

  const getDashboardData = (key) => {
    // setShowSpinner(true);
    fetch(
      getURL(
        key === POLICY_NAVIGATOR ? "FAA_DASHBOARD" : "HEALTH_CARE_DASHBOARD"
      ),
      {
        method: "GET",
        redirect: "follow",
      }
    )
      .then((response) => response.text())
      .then((result) => {
        const data = JSON.parse(result);
        setDashboardStats({
          costs: data.costs,
          queries: data.queries,
          tokens: data.tokens,
        });
        setGPUStatistics(data.stats[0]);
        // setShowSpinner(false);
      })
      .catch((error) => {
        // setShowSpinner(false);
        console.log("error", error);
        notify();
      });
  };

  const onTabClick = (key) => {
    if (key === "Dashboard") {
      getDashboardData(selectedTab);
      // getStats();
    }
    setHidePrevChatPanel(key === "Dashboard");
  };

  const handleBack = () => {
    navigate("/");
  };

  const renderTabs = () => {
    return (
      <Tabs
        defaultActiveKey={"Chat"}
        id="uncontrolled-tab-example"
        className="mb-3"
        onSelect={onTabClick}
      >
        <Tab eventKey={"Chat"} title={"Chat"}>
          <OldConvo
            chat={isPolicyNavigator ? chat : healthCareChat}
            isDataLoading={gifyOpen}
            data={isPolicyNavigator ? data : healthCareData}
            userInput={isPolicyNavigator ? userInput : healthCareUserInput}
            isEVR={false}
          />

          <CurrentConvo
            setChat={isPolicyNavigator ? setChat : setHealthCareChat}
            setStats={setStats}
            setGifyOpen={setGifyOpen}
            setData={isPolicyNavigator ? setData : setHealthCareData}
            chats={isPolicyNavigator ? chat : healthCareChat}
            setUserInput={
              isPolicyNavigator ? setUserInput : setHealthCareUserInput
            }
            setAllChatHistory={setAllChatHistory}
            setPid={isPolicyNavigator ? setPid : setHealthCarePid}
            pid={isPolicyNavigator ? pid : healthCarePid}
            isPolicyNavigator={isPolicyNavigator}
            setShowSpinner={setShowSpinner}
            notify={notify}
          />
        </Tab>
        <Tab eventKey={"Dashboard"} title="Dashboard">
          {dashboardStats && gpuStatistic && (
            <Dashboard
              dashboardStats={dashboardStats}
              gpuStatistic={gpuStatistic}
            />
          )}
        </Tab>
      </Tabs>
    );
  };

  const deleteChat = (delPid) => {
    setShowSpinner(true);
    let requestBody = {
      pid: delPid,
    };
    if (!isUseModel) {
      requestBody.project_name = location?.state?.projectId;
    }
    InvokePostServiceCall(
      isUseModel
        ? API.DirectLLM_delete_entry
        : API.DynamicLLMFromDb_delete_entry,
      requestBody
    )
      .then((response) => response.text())
      .then((result) => {
        console.log(JSON.parse(result));
        let res = JSON.parse(result);
        if (res.status === "ok") {
          let allchat = [...hhpcAllChat];
          const index = allchat.findIndex((chat) => chat.pid === delPid);
          if (index !== -1) {
            allchat.splice(index, 1);
            setHHPCAllChat(allchat);
            if (hhpcPid === delPid) {
              setHHPCPid(null);
              setHHPCChat([]);
              setHHPCeport({
                title: "",
                description: [],
                isFilled: false,
              });
            }
          }
        }
        setShowSpinner(false);
      })
      .catch((error) => {
        console.log(error, "delete_entry error");
        setShowSpinner(false);
        const notify = () => toast.error("Something went wrong!");
        notify();
      });
  };

  const hhpcAddReport = (chat, index) => {
    let newReport = {
      ...hhpcReport,
    };
    const rep = {
      id: numberToWords.toWords(hhpcReport.description.length + 1),
      header: chat.question,
      name: chat.question + index,
      content: JSON.parse(JSON.stringify(chat.response)),
    };
    // if (newReport.description.length === 0) {
    //   newReport.description.push(rep);
    // } else
    // if (selectedHHPCSection !== null) {
    //   newReport.description.splice(selectedHHPCSection + 1, 0, rep);
    // } else {
    //   newReport.description.push(rep);
    // }
    const fIndex = newReport.description.findIndex(
      (details) => details.name === rep.name
    );
    if (fIndex === -1) {
      newReport.description.push(rep);
    } else {
      newReport.description[fIndex] = rep;
    }

    newReport.isFilled = true;
    setHHPCeport(newReport);
    setHHPCSelectedSection(null);
  };
  const hhpcDeleteSection = () => {
    if (hhpcReport.description.length !== 0 && selectedHHPCSection !== null) {
      let newReport = { ...hhpcReport };
      newReport.description.splice(selectedHHPCSection, 1);
      // let newAllChat = [...hhpcAllChat];
      // const index = newAllChat.findIndex((chat) => chat.pid === evrPid);
      // if (index !== -1) {
      //   newAllChat[index].reportList = [...newReport.description];
      //   setEVRAllChat(newAllChat);
      // }
      setHHPCeport(newReport);
      setHHPCSelectedSection(null);
    }
  };
  const hhpcGenerateDoc = (isDoc = true) => {
    try {
      setShowSpinner(true);
      // saveDocumnet();
      const urlRegex = /(https?:\/\/[^\s]+)/;
      let arr = [];
      arr.push({
        properties: {
          type: SectionType.CONTINUOUS,
        },
        children: [
          new Paragraph({
            text: hhpcReport.title,
            heading: HeadingLevel.TITLE,
            alignment: AlignmentType.CENTER,
            children: [new TextRun({ text: "", break: 1 })],
          }),
        ],
      });
      hhpcReport.description.forEach((description, index) => {
        arr[0].children.push(
          new Paragraph({
            text: description.header,
            heading: HeadingLevel.HEADING_1,
            thematicBreak: true,
            pageBreakBefore: index !== 0,
            // children: [new TextRun({ text: "", break: 1 })],
          })
        );
        let list = description.content.result.split("\n").map((text) => {
          const isLink = urlRegex.test(text);
          const link = text.match(urlRegex);
          const textRun = isLink
            ? new ExternalHyperlink({
                children: [
                  new TextRun({
                    text: text,
                    style: "Hyperlink",
                    break: 1,
                  }),
                ],
                link: link ? link[0] : "",
              })
            : new TextRun({
                text: text,
                break: 1,
              });
          return textRun;
        });

        arr[0].children.push(
          new Paragraph({
            // keepLines: true,
            // keepNext: true,
            spacing: {
              before: 300,
              after: 300,
              lineRule: LineRuleType.EXACT,
            },
            children: list,
          })
        );

        const docWidth = 596;
        const padding = 10;

        description.content.images
          ?.filter((image) => image.isShow)
          .forEach((image, iIndex) => {
            let im = new Image();
            im.src = `data:image/jpeg;base64,${image.image}`;

            const maxWidth = docWidth - 2 * padding;

            let width = im.width;
            let height = im.height;

            if (width > maxWidth) {
              height = (maxWidth / width) * height;
              width = maxWidth;
            }

            const img = new ImageRun({
              type: "jpeg",
              data: Uint8Array.from(atob(image.image), (c) => c.charCodeAt(0)),
              transformation: {
                width: width,
                height: height,
              },
            });

            const link = new ExternalHyperlink({
              children: [
                new TextRun({
                  text: image.url,
                  style: "Hyperlink",
                  break: 1,
                }),
              ],
              link: image.url,
            });

            //padding for centering the image
            const paddingRight = (docWidth - width) / 2;
            const paddingLeft = paddingRight;

            arr[0].children.push(
              new Paragraph({
                text: "",
                spacing: {
                  before: 300,
                  after: 300,
                  lineRule: LineRuleType.EXACT,
                },
                children: [img, link],
                indent: {
                  left: paddingLeft,
                  right: paddingRight,
                },
              })
            );
          });

        if (description.content.tables?.length > 0) {
          description.content.tables
            .filter((table) => table.isShow)
            .forEach((table) => {
              const rows = [];
              const uniqueKeys = new Set();

              table.Rows.forEach((obj) => {
                Object.keys(obj).forEach((key) => {
                  uniqueKeys.add(key);
                });
              });

              // Convert the Set to an array if needed
              const uniqueKeysArray = Array.from(uniqueKeys);
              const row = new TableRow({
                children: uniqueKeysArray.map((rowName) => {
                  return new TableCell({
                    children: [new Paragraph(rowName)],
                    shading: {
                      fill: "FFA500",
                      // type: ShadingType.PERCENT_10,
                      color: "e2df0b",
                    },
                    borders: {
                      top: {
                        style: BorderStyle.DASH_DOT_STROKED,
                        size: 1,
                        color: "ff0000",
                      },
                      bottom: {
                        style: BorderStyle.THICK_THIN_MEDIUM_GAP,
                        size: 5,
                        color: "889900",
                      },
                    },
                  });
                }),
                tableHeader: true,
              });
              rows.push(row);
              table.Rows.forEach((row) => {
                let cellArr = uniqueKeysArray.map(
                  (cell) =>
                    new TableCell({
                      children: [new Paragraph(row[cell] || "NA")],
                    })
                );
                rows.push(new TableRow({ children: cellArr }));
              });
              const docTable = new Table({
                alignment: AlignmentType.LEFT,
                rows: rows,
              });
              arr[0].children.push(
                new Paragraph({
                  text: table.Table_name,
                  heading: HeadingLevel.HEADING_2,
                  spacing: {
                    before: 300,
                    after: 300,
                  },
                })
              );
              arr[0].children.push(docTable);

              if (table.Interpretation) {
                arr[0].children.push(
                  new Paragraph({
                    text: "Analysis",
                    heading: HeadingLevel.HEADING_4,
                    thematicBreak: true,
                    spacing: {
                      before: 300,
                      after: 300,
                    },
                  })
                );
                arr[0].children.push(
                  new Paragraph({
                    // text: "Analysis",
                    // heading: HeadingLevel.HEADING_4,
                    spacing: {
                      before: 300,
                      after: 300,
                    },
                    children: [
                      new TextRun({
                        text: table.Interpretation,
                        break: 1,
                      }),
                    ],
                  })
                );
              }
            });
        }
        const references = description.content.references.split("\n");
        if (references.length > 0) {
          arr[0].children.push(
            new Paragraph({
              spacing: {
                before: 300,
                after: 300,
                lineRule: LineRuleType.EXACT,
              },
              children: references.map(
                (ref) =>
                  new ExternalHyperlink({
                    children: [
                      new TextRun({
                        text: ref,
                        style: "Hyperlink",
                        break: 1,
                      }),
                    ],
                    link: ref,
                  })
              ),
            })
          );
        }
        if (description.content.cost) {
          arr[0].children.push(
            new Paragraph({
              spacing: {
                before: 300,
                after: 300,
                lineRule: LineRuleType.EXACT,
              },
              children: [
                new TextRun({
                  text: "Cost: " + description.content.cost,
                  break: 1,
                }),
              ],
            })
          );
        }
      });

      const doc = new Document({
        sections: arr,
        compatibility: {
          version: 15,
          doNotExpandShiftReturn: true,
        },
      });
      Packer.toBlob(doc).then(async (blob) => {
        if (isDoc) {
          // let uriArr = [];
          // uriArr.push(URL.createObjectURL(blob));
          saveAs(blob, hhpcReport.title + ".docx");
          setShowSpinner(false);
          // setBlob({ uri: uriArr, blob: blob });
        } else {
        }
      });
    } catch (error) {
      console.log("error: ", error);
      setShowSpinner(false);
      notify();
    }
  };

  const isHHPCEmpty = (data) => data.header !== "" && data.content;
  const checkIsHHPCEmpty = () => {
    return (
      hhpcReport.title !== "" &&
      hhpcReport.description.length !== 0 &&
      hhpcReport.description.every(isHHPCEmpty)
    );
  };

  const getAnalysis = (tableIndex, chatIndex) => {
    let chat = [...hhpcChat];
    chat[chatIndex].response.tables[tableIndex].isLoader = true;
    setHHPCChat(chat);

    let requestBody = {
      tables_list: JSON.stringify({
        Rows: hhpcChat[chatIndex].response.tables[tableIndex].Rows,
        Table_name: hhpcChat[chatIndex].response.tables[tableIndex].Table_name,
      }).replace(/"/g, "'"),
    };

    InvokePostServiceCall(API.analysisGPT4_analysis, requestBody)
      .then((response) => response.text())
      .then((result) => {
        const parsedData = JSON.parse(result);
        let chat1 = [...hhpcChat];
        chat1[chatIndex].response.tables[tableIndex].Interpretation =
          parsedData.analysis.Interpretation;
        setHHPCChat(chat1);
      })
      .catch((error) => {
        let chat = [...hhpcChat];
        chat[chatIndex].response.tables[tableIndex].isLoader = false;
        setHHPCChat(chat);
        const notify = () => toast.error("Something went wrong!");
        notify();
        console.error(error);
        // Handle error
      })
      .finally(() => {
        let chat1 = [...hhpcChat];
        chat1[chatIndex].response.tables[tableIndex].isLoader = false;
        setHHPCChat(chat1);
      });
  };
  const renderTable = (table, tableIndex) => {
    const uniqueKeys = new Set();

    table.Rows.forEach((obj) => {
      Object.keys(obj).forEach((key) => {
        uniqueKeys.add(key);
      });
    });
    const uniqueKeysArray = Array.from(uniqueKeys);
    return (
      <div key={tableIndex} className="w-100 d-flex flex-column">
        <h2>{table.Table_name}</h2>
        <table
          style={{
            tableLayout: "fixed",
            width: "100%",
            overflow: "auto",
            borderCollapse: "collapse",
            margin: "20px 0",
          }}
        >
          <thead className="w-100">
            <tr>
              {uniqueKeysArray.map((column, index) => (
                <th
                  key={index}
                  style={{
                    border: "1px solid #dddddd",
                    padding: "8px",
                    textAlign: "left",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                  title={column}
                >
                  {column}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="w-100">
            {table.Rows.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {uniqueKeysArray.map((column, columnIndex) => (
                  <td
                    key={columnIndex}
                    style={{
                      border: "1px solid #dddddd",
                      padding: "8px",
                      textAlign: "left",
                    }}
                    className="font-weight-normal"
                  >
                    {String(row[column] || "NA")}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
        {table.Interpretation ? (
          <p>
            <strong>Analysis: </strong>
            {table.Interpretation}
          </p>
        ) : (
          <></>
        )}
      </div>
    );
  };

  // const deleteImage = (chatIndex, imageIndex) => {
  //   let report = { ...hhpcReport };
  //   report.description[chatIndex].content.images = report.description[
  //     chatIndex
  //   ].content.images.filter((image, index) => index !== imageIndex);
  //   setHHPCeport(report);
  // };
  const handleTableSelect = (chatIndex, tableIndex) => {
    let chatList = [...hhpcChat];
    chatList[chatIndex].response.tables[tableIndex].isShow =
      !chatList[chatIndex].response.tables[tableIndex].isShow;

    setHHPCChat(chatList);
  };
  const handleImageSelect = (chatIndex, imageIndex) => {
    let chatList = [...hhpcChat];
    chatList[chatIndex].response.images[imageIndex].isShow =
      !chatList[chatIndex].response.images[imageIndex].isShow;

    setHHPCChat(chatList);
  };
  const renderMarkup = (response, chatIndex) => {
    const references = response.references
      .split("\n")
      .map((str) =>
        str.replace(
          /(https?:\/\/[^\s]+)/g,
          '<a href="$1" target="_blank" class="highlight-link" style="word-wrap: break-word" >$1</a>'
        )
      )
      .join("<br>");
    const imageList = response.images?.filter((image) => image.isShow);

    return (
      <div className="d-flex flex-column w-100">
        <div className="pb-3" style={{ fontWeight: "normal" }}>
          <Markup content={marked(response.result)} />
        </div>

        {/* {response.images?.map((image, index) => (
          <div key={index} style={{ marginBottom: "40px", marginTop: "40px" }}>
            <img src={`data:image/jpeg;base64,${image}`} alt="From Flask" />
          </div>
        ))} */}
        {imageList?.length > 0 && (
          <div className="w-100 pb-5 pt-3 chat-slider">
            <Splide
              className="w-100"
              options={{
                rewind: true,
                gap: "1rem",
              }}
              aria-label="My Favorite Images"
            >
              {imageList.map((image, index) => (
                <SplideSlide key={index}>
                  <div className="d-flex flex-row">
                    <div className="d-flex flex-column">
                      <img
                        src={`data:image/jpeg;base64,${image.image}`}
                        alt={"Image " + index}
                        style={{ height: "350px" }}
                        className="mx-5"
                      />
                      <a
                        href={image.url}
                        target="_blank"
                        className="highlight-link"
                      >
                        {image.url}
                      </a>
                    </div>
                  </div>
                </SplideSlide>
              ))}
            </Splide>
          </div>
        )}
        {response.tables
          ?.filter((table) => table.isShow)
          .map((table, index) => {
            return renderTable(table, index);
          })}
        {references && <Markup content={references} />}

        {response.cost && (
          <div className="my-3">
            <span>Cost: {response.cost}</span>
          </div>
        )}
      </div>
    );
  };

  const ConvoDiv = styled.div`
    border: 0.5px solid grey;
    padding: 10px;
    border-radius: 15px;
    margin: 2%;

    .copy-icon {
      float: right;
      cursor: pointer;
      display: none;
      opacity: 0.2;
      transition: opacity 0.3s;

      &:hover {
        opacity: 1;
      }
    }

    &:hover .copy-icon {
      display: block;
      opacity: 0.2;
    }
  `;

  const renderHHPCEVR = (chat, index) => {
    return (
      <ConvoDiv key={index}>
        <>
          <div className="response-container evr-response">
            {renderMarkup(chat, index)}
          </div>
        </>
      </ConvoDiv>
    );
  };
  const renderHHPC = () => {
    return (
      <div className="evr-container">
        {openfullWidthReport && (
          <div
            className={`chat-history-evr ${
              isUseModel || !openfullWidthChat ? "fullWidth" : ""
            }`}
          >
            <HHPCOldChat
              chats={hhpcChat}
              userInput={hhpcInput}
              sendReport={hhpcAddReport}
              getAnalysis={getAnalysis}
              handleImageSelect={handleImageSelect}
              handleTableSelect={handleTableSelect}
              data={hhpcData}
              textOnly={textOnly}
              setTextOnly={setTextOnly}
              inlineRef={inlineRef}
              setInlineRef={setInlineRef}
              addReport={addReport}
              setAddReport={setAddReport}
              isUseModel={isUseModel}
            />

            <HHPCConvo
              setData={setHHPCData}
              chat={hhpcChat}
              data={hhpcData}
              languageModel={languageModel?.value}
              setChat={setHHPCChat}
              setUserInput={setHHPCUserInput}
              setAllChatHistory={setAllChatHistory}
              setShowSpinner={setShowSpinner}
              notify={notify}
              selectedProject={location?.state?.projectId}
              textOnly={textOnly}
              setTextOnly={setTextOnly}
              inlineRef={inlineRef}
              setInlineRef={setInlineRef}
              addReport={addReport}
              setAddReport={setAddReport}
              setPid={setHHPCPid}
              setHHPCAllChat={setHHPCAllChat}
              pid={hhpcPid}
              isUseModel={isUseModel}
            />
          </div>
        )}
        {!isUseModel && (
          <>
            {" "}
            <div className="expand-arrow">
              {/* <div> */}
              {openfullWidthReport && (
                <div
                  style={{ cursor: "pointer", marginBottom: "15px" }}
                  onClick={() => setOpenFullWidthChat(!openfullWidthChat)}
                >
                  {openfullWidthChat ? (
                    <ChevronRightIcon />
                  ) : (
                    <ChevronLeftIcon />
                  )}
                </div>
              )}
              {openfullWidthChat && (
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => setOpenFullWidthReport(!openfullWidthReport)}
                >
                  {openfullWidthReport ? (
                    <ChevronLeftIcon />
                  ) : (
                    <ChevronRightIcon />
                  )}
                </div>
              )}
              {/* </div> */}
            </div>
            {openfullWidthChat && (
              <div
                className={`document-evr ${
                  !openfullWidthReport ? "w-100" : ""
                }`}
                disabled={!hhpcReport.isFilled}
              >
                <div className="title-container">
                  <div className="px-3 w-10 d-flex justify-content-center">
                    <span className="font-weight-bold">Title</span>
                  </div>
                  <div className="w-90">
                    <input
                      className="w-100"
                      value={hhpcReport.title}
                      onChange={onHHPCTitleChange}
                    ></input>
                  </div>
                </div>
                {hhpcReport.description?.length > 0 && (
                  <div className="description-container">
                    {hhpcReport.description.map((details, index) => {
                      // const imageList = details.content.images.filter(
                      //   (image) => image.isShow
                      // );
                      // const tableList = details.content.tables?.filter(
                      //   (table) => table.isShow
                      // );
                      return (
                        //<>
                        <div
                          key={hhpcReport.title + index}
                          className="header-content"
                          onClick={() => selectedHHPCSectionIndexChange(index)}
                        >
                          <div className="title-container pl-0 d-flex flex-column">
                            <div
                              className={`px-3 d-flex justify-content-flex-start py-2  ${
                                isHidePrevChatPanel ? "w-10" : ""
                              }`}
                            >
                              <span className="font-weight-bold">Header</span>
                            </div>
                            <div className=" px-3 w-100">
                              <input
                                className="w-100"
                                value={details.header}
                                onChange={(event) =>
                                  onHHPCHeaderTextChange(event, index)
                                }
                                onFocus={() =>
                                  selectedHHPCSectionIndexChange(index)
                                }
                                style={{
                                  border:
                                    selectedHHPCSection === index
                                      ? "2px solid red"
                                      : "",
                                }}
                              ></input>
                            </div>
                          </div>
                          <div className="title-container pl-0 pt-1 d-flex flex-column">
                            <div
                              className={`px-3 d-flex  justify-content-flex-start ${
                                isHidePrevChatPanel ? "w-10" : ""
                              }`}
                            >
                              <span className="font-weight-bold">Content</span>
                            </div>
                            <div className="w-100 h-100">
                              {renderHHPCEVR(details.content, index)}
                            </div>
                          </div>
                          {/* {imageList?.length > 0 && (
                        <div className="title-container pl-0 pt-1 d-flex flex-column">
                          <div
                            className={`px-3 d-flex  justify-content-flex-start ${
                              isHidePrevChatPanel ? "w-10" : ""
                            }`}
                          >
                            <span className="font-weight-bold">Images</span>
                          </div>
                          <div className="w-100 h-100">
                            <ConvoDiv key={index}>
                              <>
                                <div className="response-container evr-response">
                                  {imageList?.length > 0 && (
                                    <div className="w-100 pb-5 pt-3 chat-slider">
                                      <Splide
                                        className="w-100"
                                        options={{
                                          rewind: true,
                                          gap: "1rem",
                                        }}
                                        aria-label="My Favorite Images"
                                      >
                                        {imageList.map((image, index) => (
                                          <SplideSlide key={index}>
                                            <div className="d-flex flex-row">
                                              <div className="d-flex flex-column">
                                                <img
                                                  src={`data:image/jpeg;base64,${image.image}`}
                                                  alt={"Image " + index}
                                                  style={{
                                                    height: "350px",
                                                    width: "80%",
                                                  }}
                                                  className="mx-5"
                                                />
                                                <a
                                                  href={image.url}
                                                  target="_blank"
                                                  className="highlight-link"
                                                >
                                                  {image.url}
                                                </a>
                                              </div>
                                            </div>
                                          </SplideSlide>
                                        ))}
                                      </Splide>
                                    </div>
                                  )}
                                </div>
                              </>
                            </ConvoDiv>
                          </div>
                        </div>
                      )} */}
                          {/* {tableList?.length > 0 && (
                        <div className="title-container pl-0 pt-1 d-flex flex-column">
                          <div
                            className={`px-3 d-flex  justify-content-flex-start ${
                              isHidePrevChatPanel ? "w-10" : ""
                            }`}
                          >
                            <span className="font-weight-bold">Table</span>
                          </div>
                          <div className="w-100 h-100">
                            <ConvoDiv key={index}>
                              <>
                                <div className="response-container evr-response">
                                  {tableList.map((table, index) => {
                                    return renderTable(table, index);
                                  })}
                                </div>
                              </>
                            </ConvoDiv>
                          </div>
                        </div>
                      )} */}
                        </div>
                        //</>
                      );
                    })}
                  </div>
                )}
                <div
                  className="action-conatiner px-3"
                  disabled={!hhpcReport.isFilled}
                >
                  <Button
                    style={{ height: "55px", margin: "3px" }}
                    onClick={hhpcDeleteSection}
                  >
                    Delete Section
                  </Button>
                  <Button
                    style={{ height: "55px", margin: "3px" }}
                    disabled={!checkIsHHPCEmpty()}
                    onClick={() => hhpcGenerateDoc(true)}
                  >
                    Generate Doc
                  </Button>
                  <Button
                    style={{ height: "55px", margin: "3px" }}
                    disabled={hhpcReport.description.length === 0}
                    onClick={() => setHHPCSelectedSection(null)}
                  >
                    Clear Selection
                  </Button>
                  {/* <Button
              style={{ height: "55px", margin: "3px" }}
              disabled={hhpcReport.title === ""}
              onClick={() => saveDocumnet()}
            >
              Save
            </Button> */}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    );
  };
  const onHHPCHeaderTextChange = (event, index) => {
    let newReport = { ...hhpcReport };
    newReport.description[index].header = event.target.value;
    setHHPCeport(newReport);
  };
  const selectedHHPCSectionIndexChange = (index) => {
    setHHPCSelectedSection(index);
  };

  const onHHPCTitleChange = (event) => {
    let newReport = { ...hhpcReport };
    newReport.title = event.target.value;
    setHHPCeport(newReport);
  };

  const notify = () => toast.error("Something went wrong!");
  return (
    <div className="main-chat-container">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={configurationLoading}
        // onClick={handleClose}
      >
        {/* <CircularProgress color="inherit" /> */}
        <Spinner />
      </Backdrop>
      {showSpinner && (
        <div className="custom-overlay">
          <Spinner animation="border" role="status">
            <span className="sr-only">Loading...</span>
          </Spinner>
        </div>
      )}
      {/* <ToastContainer /> */}
      <TopStrip style={{ alignItems: "center" }}>
        <div
          className="pr-2 m-auto d-flex custom-cursor-pointer"
          onClick={closePreviousChatPanel}
        >
          <MenuIcon className="fs-1" />
        </div>
        <div
          style={{
            padding: "2px",
            backgroundColor: "white",
            borderRadius: "4px",
            margin: "2px 0px",
          }}
        >
          <img
            src={logo}
            height="65px"
            width="85px"
            alt="KBR"
            style={{
              cursor: "pointer",
            }}
            onClick={handleBack}
          />
        </div>

        {isUseModel ? (
          <div
            className="custom-dropdown"
            style={{
              flex: 1,
              position: "relative",
              // top: "20px",
              fontWeight: "bold",
              fontSize: "20px",
            }}
          >
            {/* {renderDropDown()} */}
            <div style={{ marginLeft: "14%" }}>
              {/* <span>KBR Secure Advanced Analytics Platform</span>
              <br /> */}
              <span className="mobSubheader">
                Habilis - Data to Decision (D2D)
              </span>
            </div>
          </div>
        ) : (
          <div className="custom-dropdown" style={{ flex: 1 }}>
            {/* {renderDropDown()} */}
            Habilis - {location?.state?.projectId}
          </div>
        )}

        <div
          style={{
            display: "flex",
            renderDropDownalignItems: "center",
            fontSize: "12px",
            alignItems: "center",
          }}
        >
          {isUseModel ? (
            <>
              <img
                src={HabilisLogo}
                style={{
                  height: "44px",
                  width: "auto",
                  borderRadius: "4px",
                  backgroundColor: "white",
                  paddingLeft: "1.5px",
                }}
                alt="habilis-logo"
              />

              <Autocomplete
                disableClearable
                value={languageModel}
                defaultValue={languageModel}
                onChange={(event, newValue) => {
                  setLanguageModel(newValue);
                }}
                size="small"
                options={Language_Models}
                getOptionLabel={(option) => option.title}
                sx={{
                  width: "300px",
                  backgroundColor: "white",
                  borderRadius: "5px !important",
                  marginRight: "5px",
                  marginLeft: "10px",
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    // variant="standard"
                    sx={{
                      backgroundColor: "white",
                      borderRadius: "5px !important",
                    }}
                    // label="Language Model *"
                    placeholder="Language Model *"
                  />
                )}
              />
              <div style={{ color: "white" }}>
                <Button
                  style={{ backgroundColor: "#004987", borderColor: "#004987" }}
                  onClick={handleBack}
                >
                  <HomeIcon titleAccess="Back to home" />
                </Button>
              </div>
            </>
          ) : (
            <>
              <img
                src={HabilisLogo}
                style={{
                  height: "44px",
                  width: "auto",
                  borderRadius: "4px",
                  backgroundColor: "white",
                  paddingLeft: "1.5px",
                  marginRight: "5px",
                }}
                alt="habilis-logo"
              />
              <Autocomplete
                disableClearable
                value={configurationData.language_model}
                defaultValue={configurationData.language_model}
                onChange={(event, newValue) => {
                  if (
                    newValue?.value?.includes("llama") ||
                    newValue?.value?.includes("Llama")
                  ) {
                    setConfigurationData({
                      ...configurationData,
                      language_model: newValue,
                      k: "2",
                    });
                    handleSaveConfiguration(newValue, "2");
                  } else if (newValue?.value === "gpt-3.5-turbo") {
                    setConfigurationData({
                      ...configurationData,
                      language_model: newValue,
                      k: "8",
                    });
                    handleSaveConfiguration(newValue, "8");
                  } else {
                    setConfigurationData({
                      ...configurationData,
                      language_model: newValue,
                      k: "10",
                    });
                    handleSaveConfiguration(newValue, "10");
                  }
                }}
                size="small"
                options={Language_Models}
                getOptionLabel={(option) => option.title}
                sx={{
                  width: "300px",
                  backgroundColor: "white",
                  borderRadius: "5px !important",
                  marginRight: "5px",
                  marginLeft: "10px",
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    // variant="standard"
                    sx={{
                      backgroundColor: "white",
                      borderRadius: "5px !important",
                    }}
                    // label="Language Model *"
                    placeholder="Language Model *"
                  />
                )}
              />
              <div style={{ color: "white" }}>
                <Button
                  style={{ backgroundColor: "#004987", borderColor: "#004987" }}
                  onClick={handleBack}
                >
                  <HomeIcon titleAccess="Back to home" />
                </Button>
              </div>
              {/* <div style={{ color: "white" }}>
                <Button
                  style={{ backgroundColor: "#004987", borderColor: "#004987" }}
                  onClick={handleClick}
                >
                  <LogoutIcon titleAccess="Logout" />
                </Button>
              </div> */}
            </>
          )}
        </div>
      </TopStrip>
      <div className="chat-history-container">
        {!isHidePrevChatPanel && (
          <div className="prev-chat">
            <ChatHistory
              setAllChatHistory={setAllChatHistory}
              setPreviousChat={setPreviousChat}
              isUseModel={isUseModel}
              allChat={
                selectedTab === POLICY_NAVIGATOR
                  ? allChat
                  : selectedTab === HEALTH_CARE
                  ? healthCareAllChat
                  : hhpcAllChat
              }
              isDisbaled={gifyOpen}
              pid={
                selectedTab === POLICY_NAVIGATOR
                  ? pid
                  : selectedTab === HEALTH_CARE
                  ? healthCarePid
                  : hhpcPid
              }
              isEVR={selectedTab === EVR}
              deleteChat={deleteChat}
              showDeleteButton={true}
            ></ChatHistory>
          </div>
        )}
        <div
          className={`chat-history ${
            isHidePrevChatPanel ? "w-100" : "chat-history-with-menu"
          } ${selectedTab === EVR ? "h-100" : ""}`}
        >
          {selectedTab !== EVR ? renderTabs() : renderHHPC()}
        </div>
      </div>
    </div>
  );
};

export default ChatApp;
